<template>
  <div class="batches">
    <tutorial
      v-if="tutorialVisible"
      :steps="steps"
    />

    <div
      class="width-responsiveness flex justify-between align-center mt-4 batches__subheader"
    >
      <h2>Listagem de Lotes</h2>
      <div class="flex align-center gap-3">
        <PrinterConnectionStatus
          class="mr-n3"
          label-text="Status:"
          @download-plugin-requested="handleDownloadPluginRequested"
        />
        <PrinterConfigButton
          v-if="toggle.printerPlugin && webSocketStatus.connectionState === 'connected'"
          class="mr-1"
          tooltip-direction="left"
          tooltip-text="Configurações da Impressora"
        />
        <printer-calibration />

        <PrinterHelpButton />
      </div>
    </div>

    <batches-filter ref="batchesFilter" />

    <div class="width-responsiveness mt-4">
      <md-layout class="justify-end">
        <div class="switcher-position">
          <view-switcher
            option="list"
            class="mb-n6"
            tooltip-direction="left"
            style="z-index: 99999"
            @switch-view="pushToSamples()"
          />
        </div>
      </md-layout>

      <div
        id="fake-for-highlight"
        class="fake-for-highlight"
      >
        <fake-tab
          :first-active="firstTabSelected"
          first-title="LOTES AOL"
          first-title-tooltip="Cadastros originados na plataforma 2.0."
          :first-counter="batchesCounters.aol20"
          secound-title-tooltip="Cadastros originados no sistema LIS do cliente."
          secound-title="LOTES LIS"
          :secound-counter="batchesCounters.aolWs"
          @update="fakeTabUpdate"
        />
      </div>
    </div>
    <loading-cards v-if="batchesLoading" />
    <div
      v-else
      class="width-responsiveness"
    >
      <batches-grid v-if="batchesShowGrid" />
      <empty-cart
        v-else
        class="batches__empty-cart"
        description="Não existem lotes disponíveis de acordo com a busca realizada."
        img="/static/images/icon-lotes-nao-cadastrados.svg"
      />
    </div>

    <snackbar
      ref="sampleTutorial"
      first-button-text="Não"
      second-button-text="Sim"
      ref-name="sampleTutorial"
      duration="10000"
      class="snackbar-purple-center"
      :action-button-enabled="false"
    >
      <a @click="replayTutorial()">Clique aqui para visualizar novamente o tutorial.</a>
    </snackbar>

    <PrinterPluginDownloadModal
      ref="printerPluginDownloadModal"
      ref-name="printerPluginDownloadModal"
    />
  </div>
</template>

<script>
import BatchesGrid from '@/components/PrintTag/Batches/BatchesGrid'
import LoadingCard from '@/components/PrintTag/Batches/Cards/LoadingCard'
import EmptyCart from '@/components/common/EmptyCart'
import { mapGetters, mapActions } from 'vuex'
import notify from '@/api/notification'
import ViewSwitcher from '@/components/common/ViewSwitcher'
import Snackbar from '@/components/Snackbar/Snackbar'
import Tutorial from '@/components/common/tutorial/Tutorial'
import strings from '@/strings'
import FakeTab from '../../common/FakeTab.vue'
import Alert from '@/components/common/Alert'
import BatchesFilter from '@/components/PrintTag/Batches/BatchesFilter'
import SubHeader from '../../common/SubHeader.vue'
import PrinterConfigButton from '@/components/common/printer/PrinterConfigButton'
import PrinterConnectionStatus from '@/components/common/printer/PrinterConnectionStatus.vue'
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal.vue'
import PrinterCalibration from '@/components/common/calibration/PrinterCalibration.vue'
import PrinterHelpButton from '@/components/common/printer/PrinterHelpButton.vue'

export default {
  name: 'Batches',
  components: {
    'batches-grid': BatchesGrid,
    'loading-cards': LoadingCard,
    'empty-cart': EmptyCart,
    'view-switcher': ViewSwitcher,
    snackbar: Snackbar,
    tutorial: Tutorial,
    FakeTab,
    Alert,
    BatchesFilter,
    SubHeader,
    PrinterConfigButton,
    PrinterConnectionStatus,
    PrinterPluginDownloadModal,
    PrinterCalibration,
    PrinterHelpButton,
  },
  data: () => ({
    steps: strings.printTutorial,
    alertSamples: strings.alerts.alertSamples,
  }),
  computed: {
    ...mapGetters([
      'batches',
      'batchesShowGrid',
      'batchesCurrentTab',
      'batchesCounters',
      'hasBatchesUnprinted',
      'hasBatchesPrinted',
      'batchesLoading',
      'batchesLoadingStatus',
      'isBatchDetailsShowing',
      'batchesUnprinted',
      'batchesPrinted',
      'currentBatchOpenIndex',
      'isTutorialRead',
      'profile',
      'toggle',
      'webSocketStatus',
    ]),
    firstTabSelected() {
      return this.batchesCurrentTab === 'aol20'
    },
    title: function () {
      if (!this.isBatchDetailsShowing) {
        return 'Listagem de Lotes:'
      } else {
        return 'Detalhes do lote'
      }
    },
    tutorialVisible: function () {
      return !this.batchesLoading && this.isTutorialRead === false
    },
  },
  watch: {
    batchesLoadingStatus: function (newValue) {
      if (newValue === 'STATUS_FAILED') {
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: this.reload,
          },
        })
      }
    },
  },
  methods: {
    ...mapActions(['batcheSetTab', 'selectBatchList', 'resetTutorial']),
    fakeTabUpdate(val) {
      if (val) {
        this.batcheSetTab('aol20')
      } else {
        this.batcheSetTab('aolWs')
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Impressão de Etiquetas - Lote',
          action: 'Selecionar aba AOLWS',
          'id-user': this.profile.id,
          'id-lab': this.profile.id_laboratory,
          'name-lab': this.profile.laboratoryName,
        })
      }
    },
    closeTutorialSnackbar() {
      this.$refs.sampleTutorial.close()
    },
    reload() {
      window.location.reload()
    },
    replayTutorial() {
      this.resetTutorial()
      this.closeTutorialSnackbar()
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: 'Replay do tutorial via snackbar',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    pushToSamples() {
      const queryParams = {}
      const batchFilters = this.$refs.batchesFilter.getCurrentFilters()

      if (batchFilters.startDate) queryParams.startDate = batchFilters.startDate
      if (batchFilters.endDate) queryParams.endDate = batchFilters.endDate

      queryParams.dateType = 'TD'

      if (batchFilters.packagingType) {
        queryParams.packagingType = batchFilters.packagingType
      }

      queryParams.tab = this.batchesCurrentTab

      this.$router.push({
        path: '/print-tag/samples',
        query: queryParams,
      })

      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: 'Visualizar como lista',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    handleDownloadPluginRequested() {
      this.$refs.printerPluginDownloadModal.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../static/stylesheets/variables';

.batches {
  width: 100%;
  margin-top: 70px;

  &__subheader {
    height: auto !important;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    position: absolute !important;
    background-color: #ebebeb;
    top: 58px;
    z-index: 10;
    left: 0;

    h2 {
      font-size: 22px;
      font-weight: normal;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }

    .websocket-icon {
      display: flex;
      justify-content: center;
      align-content: center;

      .md-icon {
        padding: 4px;
        width: 45px;
        height: 45px;
        top: -6px;
        right: 0;
        bottom: 0;
        left: -5px;
      }
    }

    .connected {
      color: #4caf50;
    }

    .disconnected {
      color: #f44336;
    }
  }

  &__empty-cart {
    height: calc(100vh - 350px) !important;
  }

  .width-responsiveness {
    margin-top: 20px;
    position: relative;

    .fake-for-highlight {
      border-radius: 5px;

      &.avoid-clicks {
        background-color: #ebebeb;
        .fake-tab__title--active {
          background-color: inherit;
        }
      }
    }
  }
}
</style>
